import { createFileRoute, Outlet } from "@tanstack/react-router";

import { IntakeSessionProvider } from "@/components/questionnaire/intake-session";
import { QuestionnairePage } from "@/components/questionnaire/questionnaire-page";

export const Route = createFileRoute("/intake")({
  component: IntakeLayout,
});

function IntakeLayout() {
  return (
    <QuestionnairePage>
      <IntakeSessionProvider>
        <Outlet />
      </IntakeSessionProvider>
    </QuestionnairePage>
  );
}
